import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './graphql/apolloClient';
import {
  CognitoProvider,
  configureAmplify,
} from '@sandtech-hub-monorepo/ui-auth-kit';

import App from './app/app';
import { AppRoutesPaths } from './routes/types';

configureAmplify(
  process.env['NX_USER_POOL_ID'] || '',
  process.env['NX_USER_POOL_CLIENT_ID'] || '',
  process.env['NX_IDP_DOMAIN'] || '',
  [`${window.location.origin}${AppRoutesPaths.OauthToken}`],
  [`${window.location.origin}${AppRoutesPaths.Login}`],
  process.env['NX_COOKIE_DOMAIN'] || ''
);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <CognitoProvider>
      <ApolloProvider client={client}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ApolloProvider>
    </CognitoProvider>
  </StrictMode>
);
